import type { ApplicationInsights } from "@microsoft/applicationinsights-web";
import removeAccents from 'remove-accents';

export function uuid(): string {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}


export function getTraceId(appInsights?: ApplicationInsights): string | undefined {
    if (appInsights) {
        const possibleTraceId = appInsights?.context?.telemetryTrace?.traceID;
        if (possibleTraceId) {
            return possibleTraceId;
        }
    }
    return "not_present";
}

export const normalizeAndRemoveAccents = (text: string): string => {
    return removeAccents(text)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
};
